import {
  CategoryTreeNode,
  IExtendedTreeNodeInstance,
} from './CategoryTreeNode';

export class SiblingNodesList {
  constructor(private readonly nodes: IExtendedTreeNodeInstance[]) {}

  public toArray(): CategoryTreeNode[] {
    const nodes = this.nodes.map(node =>
      CategoryTreeNode.fromServerModel(node)
    );

    if (nodes.length > 0) {
      nodes[0].first = true;
      nodes[nodes.length - 1].last = true;
    }

    return nodes;
  }
}
